<template>
  <router-link :to="link"
    v-line-clamp="lineClamp" class="mb-0 card-header--title t-md"
    v-html="capitalizedTitle"
    :title="textTitle">
  </router-link>
</template>

<script>
export default {
  name: 'searchResultPartialTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    lineClamp: {
      type: Number,
      default: 5
    },
    link: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    textTitle () {
      return this.stripTags(this.title)
    },
    capitalizedTitle () {
      return this.$options.filters.capitalize(this.title)
    }
  }
}
</script>
